import classNames from 'classnames';
import { motion, MotionProps } from 'framer-motion';
import React from 'react';
import styles from './index.module.scss';

interface MotionTextProps extends MotionProps {
  id?: string;
  as?: keyof JSX.IntrinsicElements; // Allows h1, h2, p, span, etc.
  className?: string;
  text: React.ReactNode | string;
  onClick?: (arg?: any) => void;
  role?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  tabIndex?: number;
  style?: any;
}

export const MotionText: React.FC<MotionTextProps> = ({
  id,
  as: Component = 'p',
  className = '',
  text,
  initial = {},
  animate = {},
  exit = {},
  transition = {},
  onClick,
  role,
  style,
  ...rest
}) => (
  <motion.div
    initial={initial}
    animate={animate}
    exit={exit}
    transition={transition}
    onClick={onClick}
    className={classNames(styles.textStyles, className)}
    role={role}
    onKeyDown={rest.onKeyDown}
    tabIndex={rest.tabIndex}
    style={style}
    {...rest}
  >
    <Component id={id} className={classNames(styles.textElement, className)} style={style}>
      {text}
    </Component>{' '}
  </motion.div>
);

MotionText.defaultProps = {
  id: '',
  as: 'p',
  className: classNames(styles.textStyles),
  onClick: () => null,
  role: 'status',
  onKeyDown: () => null,
  tabIndex: 0,
  style: null,
};
